import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, Variants } from 'framer-motion';
import { Box, Typography } from '@mui/material';

// The original list of words
const WORDS = [
  "FinOps.",
  "Troubleshooting.",
  "Security Posture.",
];

// The delay between each word change in milliseconds
const DELAY_INTERVAL = 2000;
// The duration of the "slide" animation
const ANIMATION_DURATION = 0.8;

// This should be slightly larger than the line-height of your text
const ITEM_HEIGHT = '1.3em';

const RotatingText: React.FC = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(prevIndex => (prevIndex + 1) % WORDS.length);
    }, DELAY_INTERVAL);

    // Clean up the timer when the component is unmounted
    return () => clearInterval(timer);
  }, []);

  // THE FIX: Explicitly type the variants object with the 'Variants' type
  // from Framer Motion and remove the 'as const' assertion.
  // This ensures the keyframe array is mutable as expected.
  const slideUpVariants: Variants = {
    initial: { y: '100%' },
    animate: { y: '0%' },
    exit: {
      y: ['0%', '10%', '-100%'], // Keyframes: stay -> dip down -> exit up
      transition: {
        duration: ANIMATION_DURATION,
        ease: 'easeInOut',
        // The `times` array maps the keyframes in `y` to the duration.
        // The dip to 20% happens in the first 20% of the animation.
        times: [0, 0.2, 1],
      },
    },
  };

  // This transition will apply to the 'initial' and 'animate' variants.
  // The 'exit' variant's transition will override this when exiting.
  const transition = {
    type: 'tween',
    ease: 'easeInOut',
    duration: ANIMATION_DURATION,
  } as const;

  // Find the longest word to set a static width.
  const longestWord = WORDS.reduce((a, b) => (a.length > b.length ? a : b));

  return (
    <Box sx={{
      mt: 1,
      display: 'inline-block',
      position: 'relative',
      height: ITEM_HEIGHT,
    }}>
      {/* This sizer now uses the LONGEST word to prevent the container from shrinking
          during the animation, which solves the "cutting" issue.
      */}
      <Typography
        component="span"
        variant="inherit"
        aria-hidden="true" // Hide from screen readers
        sx={{
          visibility: 'hidden', // Make it take up space but not be visible
          fontWeight: 600,
        }}
      >
        {longestWord}
      </Typography>

      {/* The animated text now lives inside an absolutely positioned container */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <AnimatePresence>
          <motion.div
            key={WORDS[index]}
            variants={slideUpVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={transition}
            style={{
              position: 'absolute',
              width: '100%',
            }}
          >
            <Typography
              component="span"
              variant="inherit"
              sx={{
                background: 'linear-gradient(90deg, #0064FF, #FA72FF)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent',
                fontWeight: 500,
              }}
            >
              {WORDS[index]}
            </Typography>
          </motion.div>
        </AnimatePresence>
      </Box>
    </Box>
  );
};

export default RotatingText;





// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Box, Typography } from '@mui/material';

// // The original list of words
// const WORDS = [
//   "FinOps.",
//   "Troubleshooting.",
//   "Create policies.",
//   "Recommendations."
// ];

// // The delay between each word change in milliseconds
// const DELAY_INTERVAL = 2500;
// // The duration of the "slide" animation
// const ANIMATION_DURATION = 0.8;

// // This should be slightly larger than the line-height of your text
// const ITEM_HEIGHT = '1.3em';

// const RotatingText: React.FC = () => {
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex(prevIndex => (prevIndex + 1) % WORDS.length);
//     }, DELAY_INTERVAL);

//     // Clean up the timer when the component is unmounted
//     return () => clearInterval(timer);
//   }, []);

//   // Removed opacity for a pure slide effect
//   const slideUpVariants = {
//     initial: { y: '100%' },
//     animate: { y: '0%' },
//     exit: { y: '-100%' },
//   };

//   const transition = {
//     type: 'tween',
//     ease: 'easeInOut',
//     duration: ANIMATION_DURATION,
//   } as const;

//   // Find the longest word to set a static width.
//   const longestWord = WORDS.reduce((a, b) => (a.length > b.length ? a : b));

//   return (
//     <Box sx={{
//       mt: 1,
//       display: 'inline-block',
//       position: 'relative',
//       height: ITEM_HEIGHT,
//     }}>
//       {/* This sizer now uses the LONGEST word to prevent the container from shrinking
//           during the animation, which solves the "cutting" issue.
//       */}
//       <Typography
//         component="span"
//         variant="inherit"
//         aria-hidden="true" // Hide from screen readers
//         sx={{
//           visibility: 'hidden', // Make it take up space but not be visible
//           fontWeight: 600,
//         }}
//       >
//         {longestWord}
//       </Typography>

//       {/* The animated text now lives inside an absolutely positioned container */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           overflow: 'hidden',
//         }}
//       >
//         {/* THE FIX: The "mode='wait'" prop has been removed.
//             This allows the enter and exit animations to happen simultaneously,
//             creating a continuous, overlapping effect.
//         */}
//         <AnimatePresence>
//           <motion.div
//             key={WORDS[index]}
//             variants={slideUpVariants}
//             initial="initial"
//             animate="animate"
//             exit="exit"
//             transition={transition}
//             style={{
//               position: 'absolute',
//               width: '100%',
//             }}
//           >
//             <Typography
//               component="span"
//               variant="inherit"
//               sx={{
//                 background: 'linear-gradient(90deg, #0064FF, #FA72FF)',
//                 WebkitBackgroundClip: 'text',
//                 backgroundClip: 'text',
//                 color: 'transparent',
//                 fontWeight: 600,
//               }}
//             >
//               {WORDS[index]}
//             </Typography>
//           </motion.div>
//         </AnimatePresence>
//       </Box>
//     </Box>
//   );
// };

// export default RotatingText;


// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Box } from '@mui/material';

// // The list of words you want to rotate
// const WORDS = [
//   "FinOps.",
//   "Troubleshooting.",
//   "Create policies.",
//   "Recommendations."
// ];

// const RotatingText: React.FC = () => {
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex((prevIndex) => (prevIndex + 1) % WORDS.length);
//     }, 3000); // Rotates every 3 seconds

//     // Cleanup interval on component unmount
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Box sx={{
//         mt:1,
        
//         display: 'inline-block',
//         position: 'relative',
//         // This height ensures the layout doesn't jump as text animates
//         height: '1.1em', 
//         maxWidth: '250px', // Adjust width based on your longest word
//       }}>
//       <AnimatePresence>
//         <motion.span
//           // The key is crucial for AnimatePresence to track which item is entering/exiting
//           key={index}
//           // Animation states
//           initial={{ y: 30, opacity: 0 }} // Starts below and invisible
//           animate={{ y: 0, opacity: 1 }}   // Animates to original position and visible
//           exit={{ y: -30, opacity: 0 }}    // Exits by moving up and fading out
//           // Transition settings for a smooth animation
//           transition={{ duration: 0.5, ease: 'easeInOut' }}
//           style={{
//             // This makes the words animate on top of each other in the same spot
//             position: 'absolute',
//             // --- PLACEHOLDER FOR YOUR GRADIENT ---
//             // This is where your linear-gradient color will go.
//             // Using a solid color for now.
//             //background: 'linear-gradient(93.48deg, #0064FF 2.9%, #FA72FF 39.42%)';

//             background: 'linear-gradient(90deg, #0064FF, #FA72FF)',
//             WebkitBackgroundClip: 'text',
//             backgroundClip: 'text',
//             color: 'transparent',
//           }}
//         >
//           {WORDS[index]}
//         </motion.span>
//       </AnimatePresence>
//     </Box>
//   );
// };

// export default RotatingText;